import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BlueRightArrow from '../../../assets/ArrowRight.svg';
import BlueLeftArrow from '../../../assets/ArrowLeft.svg';
import './MobileNumberList.scss';
function MobileNumberList({ id, rtl, data, buttonText = "Send Code", onClick }) {
    const handleClick = (el) => {
        onClick(el);
    };
    return (_jsx("div", Object.assign({ className: 'mobileNumber_container' }, { children: data.map((el, index) => {
            return (_jsxs("div", Object.assign({ className: 'mobileNumber__List', style: rtl ? { direction: "rtl" } : { direction: "ltr" } }, { children: [_jsx("p", Object.assign({ className: 'masked_mobileNumber' }, { children: el === null || el === void 0 ? void 0 : el.maskedMSISDN }), void 0), _jsxs("div", Object.assign({ id: id, onClick: () => handleClick(el), className: "mobileNumber_sendCode" }, { children: [_jsx("p", Object.assign({ className: 'mobileNumber_buttonText' }, { children: buttonText }), void 0), _jsx("img", { src: rtl ? BlueLeftArrow : BlueRightArrow, alt: "arrowIcon" }, void 0)] }), void 0)] }), index));
        }) }), void 0));
}
export default MobileNumberList;
